import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import Camera from '@/assets/svgs/permission/camera.svg';
import ImgPicker from '@/assets/svgs/permission/img-picker.svg';
import Location from '@/assets/svgs/permission/location.svg';
import Notification from '@/assets/svgs/permission/notification.svg';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import type { DeviceTokenData } from '@/stores/DeviceStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { getAppStoreUrls } from '@/utils/appDownload';
import { useHandleApp } from '../_hooks/useHandleApp';
import { MESSAGE_KEYWORD } from '../_utils/reserved-keywords';
export const AppModal = () => {
  const $ = _c(48);
  const [appModal, setAppModal, setTempDeviceTokenData, osType] = useDeviceInfoStore(useShallow(_temp));
  const {
    isOpened,
    type
  } = appModal;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: MESSAGE_KEYWORD.EXIT_APP
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    request: requestExit
  } = useHandleApp(t0);
  let t1;
  if ($[1] !== setAppModal || $[2] !== type) {
    t1 = () => setAppModal({
      type,
      isOpened: false
    });
    $[1] = setAppModal;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const closeModal = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: MESSAGE_KEYWORD.CHECK_PERMISSION
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    request: requestCheckPermission
  } = useHandleApp(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      type: MESSAGE_KEYWORD.NOTIFICATION
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    request: requestNotification,
    response: notificationResponse
  } = useHandleApp(t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      type: MESSAGE_KEYWORD.SYSTEM_SETTINGS
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    request: requestSystemSettings
  } = useHandleApp(t4);
  const [isSwiftPending, setIsSwiftPending] = useState(false);
  const [needsSettings, setNeedsSettings] = useState(false);
  let t5;
  let t6;
  if ($[7] !== isSwiftPending || $[8] !== requestNotification) {
    t5 = () => {
      if (!isSwiftPending) {
        return;
      }
      if (navigator.userAgent.includes("swift") || navigator.userAgent.includes("ios")) {
        const id = setTimeout(requestNotification, 5000);
        return () => clearTimeout(id);
      }
    };
    t6 = [isSwiftPending, requestNotification];
    $[7] = isSwiftPending;
    $[8] = requestNotification;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[11] !== notificationResponse || $[12] !== requestCheckPermission || $[13] !== setAppModal || $[14] !== setTempDeviceTokenData) {
    t7 = () => {
      const {
        data,
        isSuccess
      } = notificationResponse ?? {};
      if (notificationResponse && !isSuccess) {
        const deniedData = data as unknown as {
          needsSettings?: boolean;
        } | undefined;
        if (deniedData?.needsSettings) {
          setNeedsSettings(true);
          setAppModal({
            type: "permission",
            isOpened: true
          });
        }
        return;
      }
      if (isSuccess && data) {
        if (navigator.userAgent.includes("swift") || navigator.userAgent.includes("ios")) {
          if (data.fcm_token) {
            setTempDeviceTokenData(data);
            setIsSwiftPending(false);
          } else {
            setIsSwiftPending(true);
          }
        } else {
          setTempDeviceTokenData(data);
        }
        requestCheckPermission({
          permissionType: MESSAGE_KEYWORD.LOCATION
        });
      }
    };
    t8 = [notificationResponse, requestCheckPermission, setAppModal, setTempDeviceTokenData];
    $[11] = notificationResponse;
    $[12] = requestCheckPermission;
    $[13] = setAppModal;
    $[14] = setTempDeviceTokenData;
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  useEffect(t7, t8);
  let t9;
  if ($[17] !== closeModal || $[18] !== needsSettings || $[19] !== type) {
    t9 = () => {
      if (needsSettings) {
        setNeedsSettings(false);
        closeModal();
        return;
      }
      if (type !== "permission" && type !== "forceUpdate") {
        closeModal();
      }
    };
    $[17] = closeModal;
    $[18] = needsSettings;
    $[19] = type;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== closeModal || $[22] !== needsSettings || $[23] !== osType || $[24] !== requestNotification || $[25] !== requestSystemSettings) {
    t10 = needsSettings ? <article className="flex flex-col items-center gap-8"><h2 className="text-center font-700 typo-h5">알림이 차단되어 있어요</h2><p className="mb-16 text-center text-Gray-600 typo-body4">기기 설정에서 알림을 허용하면<br />맞춤 정보를 받아볼 수 있어요.{osType !== "ios" ? <><br />설정 화면에서 「알림」을 눌러 켜주세요.</> : null}</p><Button onClick={() => {
        requestSystemSettings();
        setNeedsSettings(false);
        closeModal();
      }}>설정으로 이동</Button><Button theme="sub-text" onClick={() => {
        setNeedsSettings(false);
        closeModal();
      }}>다음에 할래요</Button></article> : <article className="flex h-full max-h-[70vh] flex-col"><h2 className="mb-8 font-700 typo-body1">서비스 이용을 위한<br />권한 접근이 필요해요.</h2><div className="flex flex-1 flex-col gap-20 overflow-y-auto"><section className="flex flex-col gap-16 border-b-1 border-Gray-300 pb-20"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">필수 접근 권한</h3><p className="text-Gray-600 typo-body4">필수적 접근 권한 없음</p></div></section><section className="flex flex-col gap-16 border-b-1 border-Gray-300 pb-20"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">선택적 접근 권한</h3><p className="text-Gray-600 typo-body4">선택적 접근 권한은 해당 기능을 사용할 때 허용이 필요하며, 비허용 시에도 해당 기능 외 서비스 이용이 가능합니다.</p></div><ul className="flex flex-col gap-10 px-16">{[{
              icon: Notification,
              title: "\uC54C\uB9BC(\uC120\uD0DD)",
              description: "\uAC1C\uC778\uBCC4 \uB9DE\uCDA4 \uC815\uBCF4 \uC54C\uB9BC"
            }, {
              icon: Location,
              title: "\uC704\uCE58(\uC120\uD0DD)",
              description: "\uAC80\uC0C9 \uBC0F \uB3D9\uB124\uC18C\uC2DD\uC5D0\uC11C \uD604\uC7AC \uC704\uCE58 \uC0AC\uC6A9"
            }, {
              icon: Camera,
              title: "\uCE74\uBA54\uB77C(\uC120\uD0DD)",
              description: "\uB2F5\uB840\uD488 \uD6C4\uAE30, \uBB38\uC758, \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 \uB4F1\uB85D"
            }, {
              icon: ImgPicker,
              title: "\uC0AC\uC9C4(\uC120\uD0DD)",
              description: "\uB2F5\uB840\uD488 \uD6C4\uAE30, \uBB38\uC758, \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 \uB4F1\uB85D"
            }].map(_temp2)}</ul></section><section className="flex flex-col gap-16 pb-16"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">접근 권한 변경 방법</h3><p className="text-Gray-600 typo-body4">휴대폰 설정 {">"} 앱 또는 애플리케이션 관리 {">"} 웰로{" "}{">"} 권한에서 각 권한별 변경 가능합니다.</p></div></section></div><Button className="mt-16" onClick={async () => {
        requestNotification();
        closeModal();
      }}>확인</Button></article>;
    $[21] = closeModal;
    $[22] = needsSettings;
    $[23] = osType;
    $[24] = requestNotification;
    $[25] = requestSystemSettings;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <h2 className="text-center font-700 typo-h5">앱을 나가시겠어요?</h2>;
    t12 = <p className="mb-16 text-Gray-600 typo-body4">더이상 뒤로 갈 페이지가 없어요.</p>;
    $[27] = t11;
    $[28] = t12;
  } else {
    t11 = $[27];
    t12 = $[28];
  }
  let t13;
  if ($[29] !== closeModal) {
    t13 = <Button onClick={closeModal}>계속 볼게요</Button>;
    $[29] = closeModal;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== requestExit) {
    t14 = <Button theme="sub-text" onClick={() => requestExit()}>나갈게요</Button>;
    $[31] = requestExit;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <article className="flex flex-col items-center gap-8">{t11}{t12}{t13}{t14}</article>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <h2 className="text-center font-700 typo-h5">업데이트가 필요해요</h2>;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <p className="mb-16 text-Gray-600 typo-body4">원활한 서비스 이용을 위해<br />최신 버전으로 업데이트해 주세요.</p>;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== osType) {
    t18 = <article className="flex flex-col items-center gap-8">{t16}{t17}<Button onClick={() => {
        window.location.href = getAppStoreUrls(osType === "ios" ? "ios" : "android").schemeUrl;
      }}>업데이트하기</Button></article>;
    $[38] = osType;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t10 || $[41] !== t15 || $[42] !== t18) {
    t19 = {
      permission: t10,
      exit: t15,
      forceUpdate: t18
    };
    $[40] = t10;
    $[41] = t15;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  const t20 = t19[type];
  let t21;
  if ($[44] !== isOpened || $[45] !== t20 || $[46] !== t9) {
    t21 = <ResponsiveDialog opened={isOpened} onClose={t9} ariaLabel={"\uC571 \uC548\uB0B4"} drawerType="bottom">{t20}</ResponsiveDialog>;
    $[44] = isOpened;
    $[45] = t20;
    $[46] = t9;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  return t21;
};
function _temp(state) {
  return [state.appModal, state.setAppModal, state.setTempDeviceTokenData, state.osType];
}
function _temp2(t0, index) {
  const {
    icon: Icon,
    title,
    description
  } = t0;
  return <li key={index} className="flex items-center gap-16"><div className="size-48 rounded-pill bg-Gray-100 flex-center"><Icon alt={title} /></div><div className="flex flex-col gap-2"><h4 className="font-700 text-Gray-900 typo-body4">{title}</h4><p className="text-Gray-600 typo-body4">{description}</p></div></li>;
}